/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Pending_TitleInputs */



/**
* | output |
* | --- |
* | "Your report is on its way" |
*
* @param {Meeting_Report_Pending_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_pending_title = /** @type {((inputs?: Meeting_Report_Pending_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Pending_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je verslag komt eraan")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre compte rendu arrive")
	return /** @type {LocalizedString} */ ("Your report is on its way")
});